/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  notes: 'Notizen',
  note: 'Notiz',
  save: 'speichern',
  pin: 'anheften',
  unpin: 'loslösen',
  unpinFailure: 'Die Notiz konnte nicht losgelöst werden.',
  download: 'herunterladen',
  share: 'teilen',
  shareSuccess: 'Notiz erfolgreich geteilt.',
  shareFailure: 'Notiz konnte nicht geteilt werden.',
  delete: 'löschen',
  deletePrompt: 'Sind Sie sicher, dass Sie diese Notiz löschen möchten?',
  search: 'suchen',
  syncFailure: 'Notizen konnten nicht synchronisiert werden.',
  filter: 'filtern',
  keyword: 'Stichwort',
  newNote: 'neue Notiz',
  add: 'hinzufügen',
  created: 'Erstellt',
  modified: 'Angepasst',
  characters: 'Zeichen',
  selectNote: 'Notiz Auswählen',
  selectNoteInformation: 'Diese Anzeige zeigt nützliche Informationen und Aktionen an, sobald Sie eine Notiz aus der Notizliste auswählen.',
  welcome: 'Willkommen!',
  selectNoteOrCreate: 'Wählen Sie eine Notiz aus oder erstellen Sie eine neue Notiz.',
  conflict: 'Konflikt',
  syncingGotDisabled: 'Die Notensynchronisation wurde aufgrund von unerwarteten Fehlern deaktiviert.',
  notFoundOrNotSynced: 'Die Notiz wurde nicht gefunden oder ist noch nicht synchronisiert.',
}
